// theme.js
export const colors = {
  primary: "rgba(112,0,0,1)",
  secondary: "rgba(10,0,0,1)",
  // Add more color values as needed
};
